
export const keepTruthy = <T>(...args: T[]): T[] => {
  return args.filter(arg => arg);
}